import { FC, PropsWithChildren } from "react";
import { Box, Flex, Text } from "@smile2impress/components/relaunch";
import { useCookiesPolicyContext } from "@smile2impress/cookies-banner";

import {
    SocialIconNameType,
    SocialMediaIcon,
} from "components/Icons/SocialMediaIcon";
import Link from "components/Link";

export type FooterLinkProps = {
    name: string;

    id?: string;
    target?: string;
    icon?: SocialIconNameType;
} & OneOf<{ link: string; newPatientsLink?: string }, { cookiesSetting: true }>;

export const FooterLink: FC<FooterLinkProps> = ({
    link,
    name,
    icon,
    target = "_self",
    cookiesSetting = false,
}) => {
    const { setIsCookiesPopupVisible } = useCookiesPolicyContext();

    const onCookiesClick = () => {
        setIsCookiesPopupVisible(true);
    };

    if (!link || !name) return null;

    const LinkWrapper = ({ children }: PropsWithChildren) => (
        <Link
            target={target}
            href={link}
            display="flex"
            alignItems="center"
            color="text.base"
            mb={2}
            cursor="pointer"
            noNextRouting={
                link.endsWith(".pdf") ||
                link.startsWith("tel:") ||
                link.startsWith("mailto:") ||
                link.startsWith("https:")
            }
            {...(link.startsWith("http") ? { rel: "nofollow" } : {})}
        >
            {children}
        </Link>
    );

    return link || cookiesSetting ? (
        <Flex
            as={cookiesSetting ? Box : LinkWrapper}
            alignItems="center"
            {...(cookiesSetting ? { onClick: onCookiesClick } : {})}
        >
            <>
                {icon && (
                    <Box maxHeight={5} py={[1]} mr={2}>
                        <SocialMediaIcon iconName={icon} />
                    </Box>
                )}
                <Text textStyle="caption" fontWeight="body">
                    {name}
                </Text>
            </>
        </Flex>
    ) : null;
};
